import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const headerWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const summary: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
};

export const summaryActions: SxStyle = {};
